import {V3Record} from 'data/helpers/V3Record.js'
import {capitalize} from 'lib/utils'

export const CollectionItem = V3Record('collectionItem', {
  collectionId: null, // integer
  itemId: null, // integer
  itemType: null, // string
  position: null // integer
})

// we want to keep itemType lowercased in redux, but rails wants it capitalized
// for the polymorphic association
const _defaultDeserialize = CollectionItem.deserialize
const _defaultSerialize = CollectionItem.serialize
CollectionItem.deserialize = (fromRails) => {
  const item = _defaultDeserialize(fromRails)
  return item.set('itemType', item.itemType.toLowerCase())
}

// reverse the above operation
CollectionItem.serialize = (toRails) => {
  const response = _defaultSerialize(toRails)
  response.collection_item.item_type = capitalize(toRails.itemType)
  return response
}
